<template>
  <div>
    <v-main>
      <v-app-bar color="primary" flat app dark>
        <v-spacer></v-spacer>
        <!-- <v-app-bar-title>アカウント作成</v-app-bar-title> -->
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-container fluid>
        <!-- <v-form>
          <div>
            <p class="body-2 blue-grey--text">姓</p>
            <v-text-field v-model="postMeRequest.firstName" outlined dense></v-text-field>
          </div>

          <div>
            <p class="body-2 blue-grey--text">名前</p>
            <v-text-field v-model="postMeRequest.lastName" outlined dense></v-text-field>
          </div>

          <div>
            <p class="body-2 blue-grey--text">姓カナ</p>
            <v-text-field v-model="postMeRequest.firstNameKana" outlined dense></v-text-field>
          </div>

          <div>
            <p class="body-2 blue-grey--text">名前カナ</p>
            <v-text-field v-model="postMeRequest.lastNameKana" outlined dense></v-text-field>
          </div>

          <div class="d-flex justify-center my-5">
            <v-btn @click="postMe" color="primary" block :loading="btnLoading">
              作成
            </v-btn>
          </div>
          <div class="d-flex justify-center my-5">
            <v-btn @click="logout" color="primary" block outlined>
              ログアウト
            </v-btn>
          </div>
        </v-form> -->
        <div class="d-flex justify-center my-5">
          <p>
            {{ $t('signup.noNurseryFound') }}
          </p>
        </div>
        <div class="d-flex justify-center my-5">
          <v-btn @click="toTop" color="primary" block :loading="btnLoading">
            {{ $t('signup.goToTop') }}
          </v-btn>
        </div>
        <div class="d-flex justify-center my-5">
          <v-btn @click="logout" color="primary" block outlined>
            {{ $t('signup.logout') }}
          </v-btn>
        </div>
      </v-container>
    </v-main>
  </div>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";

import { PostMeRequest } from '@/model/Request';
import { meModule } from '@/store/dataModules/meModule';
import { auth0Module } from '@/store/dataModules/auth0Module';

interface DataType {
  postMeRequest: PostMeRequest;
}

export default defineComponent({
  data: () => ({
    postMeRequest: {
      firstName: '',
      lastName: '',
      firstNameKana: '',
      lastNameKana: '',
    },
    btnLoading: false,
  }),

  methods: {
    // async postMe() {
    //   try {
    //     this.btnLoading = true
    //     const response = await meModule.postMe(this.postMeRequest);
    //     console.log(response);
    //     this.btnLoading = false
    //     this.$router.push('/');
    //   } catch (error) {
    //     console.log(error);
    //   } finally {
    //     this.btnLoading = false
    //   }
    // },
    toTop() {
      this.$router.push('/');
    },
    logout() {
      auth0Module.logout();
    },
  },
});
</script>
<style lang="scss" scoped></style>
